// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"829":"a1fadf73","878":"4dd45f3a"}[chunkId] + ".chunk.js";
};